import type { FromModel } from "@/__main__/data-model.mjs";
import createModel, { arbitraryKeys, Silent } from "@/__main__/data-model.mjs";

const Stats = createModel({
  apiKey: String,
  name: String,
  type: Silent(String),
  description: Silent(String),
  bonuses: [
    {
      needed: Number,
      max: Number,
      style: Number,
      effect: String,
    },
  ],
});

const apiModelValidation = createModel({
  [arbitraryKeys]: Stats,
});

function transform(data) {
  return apiModelValidation(data);
}

export default transform;

export type TFTTraits = FromModel<typeof apiModelValidation>;
